import React, { useState, useEffect } from 'react'

import { useSelector } from 'react-redux'

import { Button, Input, Typography, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import RpcApiClient from 'datasources/RpcApiClient'

const { Text } = Typography

function UserInfo(props) {
  const authData = useSelector((state) => state.auth.authData)

  //const queryUserInfo = useQuery(GET_PERSONAL_USER_INFO)
  const [name, setName] = useState(undefined)
  const [last_name, setLasName] = useState(undefined)

  const [loadingUserInfo, setLoadingUserInfo] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const [loadingUpdateUserInfo, setLoadingUpdateUserInfo] = useState(false)

  const getUserInfo = () => {
    setLoadingUserInfo(false)
    RpcApiClient.getUserInfo(authData.jwtToken).then((data) => {
      setUserInfo(data.data.data)
      setName(data.data.data.name)
      setLasName(data.data.data.last_name)
      setLoadingUserInfo(true)
    })
  }

  const updateUserInfo = (body) => {
    setLoadingUpdateUserInfo(false)
    RpcApiClient.updateUserInfo(authData.jwtToken, body).then((data) => {
      setLoadingUpdateUserInfo(true)
      getUserInfo()
    })
  }

  useEffect(() => {
    getUserInfo()
  }, [])

  if (loadingUserInfo) {
    return (
      <div style={{ height: '100%' }}>
        <div style={{ width: '500px', marginTop: '20px', marginLeft: '20px' }}>
          <Text>Name</Text>
          <Input
            defaultValue={userInfo.name}
            value={name}
            size="large"
            style={{ marginTop: '10px' }}
            onChange={(e) => setName(e.target.value)}
          />

          <div style={{ marginTop: '15px' }}>
            <Text>Last Name</Text>
          </div>
          <Input
            defaultValue={userInfo.last_name}
            value={last_name}
            size="large"
            style={{ marginTop: '10px' }}
            onChange={(e) => setLasName(e.target.value)}
          />

          <div style={{ marginTop: '15px' }}>
            <Text>Email</Text>
          </div>
          <Input value={userInfo.email} disabled size="large" style={{ marginTop: '10px' }} />

          <Button
            type="primary"
            style={{ marginTop: '20px', float: 'left', width: '50%' }}
            onClick={() => {
              let newName = name || userInfo.name
              let newLastName = last_name || userInfo.last_name
              updateUserInfo({
                name: newName,
                last_name: newLastName,
              })
            }}
          >
            Save
          </Button>
        </div>
      </div>
    )
  } else {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <Spin style={{ marginTop: '25%' }} tip="Loading..." size="large" indicator={<LoadingOutlined />}>
          <div style={{ height: '100%', width: '100%' }}></div>
        </Spin>
      </div>
    )
  }
}

export default UserInfo
